import { IObjectAudit, IContactInfo } from "../../../models"

export interface IEmployeeEducationDocument {
    Id: string
    AccountId: string
    UserId: string
    StartDate: string | Date
    EndDate: string | Date
    SchoolName: string
    CertificationName: string
    Degree: EEducationDegree
    Major: string
    ExpirationDate: string | Date
    GPA: number
    ContactInfo: IContactInfo
    ObjectAudit: IObjectAudit
    Deleted: boolean
    TicksSinceChange: number
}

export enum EEducationDegree {
    Associates = 0,
    Bachelors = 1,
    Masters = 2,
    Doctoral = 3,
    Professional = 4,
}